import { Fragment } from 'react'
import { Box, styled } from '@mui/material'
import { useIsSmallScreen } from 'packages/core'
import { useTranslation } from 'react-i18next'
import { ItemDetails, PeopleList } from 'components'
import { useCredentialOwners, useResponsibleParty } from 'hooks'
import useSubcomponents from 'useSubcomponents'
import { PersonDetails } from 'components/ApplicationBanner/PersonDetails'

const hasAccessToOwnerControl = 'ITShop-Credentials-Details-Owners-Control'
const hasAccessToResponsiblePartyControl = 'ITShop-Credentials-Details-ResponsibleParty-Control'

const PaddedDiv = styled(Box)({
    padding: '0 31px',
})

export const MoreInformationSection = ({ credential }: any) => {
    const { t } = useTranslation()
    const { hasAccessToControl } = useSubcomponents()
    const attributeOrientation = useIsSmallScreen() ? 'vertical' : 'horizontal'

    const { data: owners, isInitialLoading: ownersLoading } =
        useCredentialOwners(
            hasAccessToControl(hasAccessToOwnerControl) ? credential.id : null,
        )

    const {
        data: responsibleParty,
        isInitialLoading: responsiblePartyLoading,
    } = useResponsibleParty(
        credential.id,
        Boolean(hasAccessToControl(hasAccessToResponsiblePartyControl))
    )

    return (
        <Fragment>
            {ownersLoading || responsiblePartyLoading ? (
                <ItemDetails.AttributesContainer>
                    <PaddedDiv>
                        <ItemDetails.AttributesLoader />
                    </PaddedDiv>
                </ItemDetails.AttributesContainer>
            ) : (
                <ItemDetails.AttributesContainer bottomPadding="0">
                    {hasAccessToControl(hasAccessToOwnerControl) && (
                        <PaddedDiv
                            data-protectedsubcomponent={
                                hasAccessToOwnerControl
                            }
                        >
                            <ItemDetails.Attribute
                                label={t('Common_Owners')}
                                value={<PeopleList list={owners} />}
                                orientation={attributeOrientation}
                            />
                        </PaddedDiv>
                    )}
                    {hasAccessToControl(hasAccessToResponsiblePartyControl) && (
                        <PaddedDiv
                            data-protectedsubcomponent={
                                hasAccessToResponsiblePartyControl
                            }
                        >
                            <ItemDetails.Attribute
                                label={t('Applications_Owner')}
                                value={
                                    responsibleParty ?
                                        <PersonDetails
                                            size="medium"
                                            person={{
                                                imageThumbUrl: responsibleParty.imageThumbUrl,
                                                friendlyName: responsibleParty.friendlyName,
                                                email: responsibleParty.email,
                                                telephone: responsibleParty.telephone,
                                            }}
                                        />
                                        : <>-</>
                                }
                                orientation={attributeOrientation}
                            />
                        </PaddedDiv>
                    )}
                </ItemDetails.AttributesContainer>
            )}
        </Fragment>
    )
}
